import axios from "axios";
const api = axios.create({ baseURL: "https://docfinder-backend.onrender.com" });
export default api;
